import React from "react";
import avatarFor, { initialsDataUri } from "../../utils/avatarFor";

// An identity avatar that never shows the browser's broken-image glyph.
// Photos uploaded before 2026-07-03 point at storage keys that no longer
// exist, so a URL being present is no promise the picture is. On error the
// image swaps to the same initials lettermark it would have shown with no
// photo at all.
const AvatarImg = ({ name, url, style, ...rest }) => (
  <img
    src={avatarFor(name, url)}
    alt=""
    onError={(e) => {
      const fallback = initialsDataUri(name);
      if (e.currentTarget.src !== fallback) e.currentTarget.src = fallback;
    }}
    style={style}
    {...rest}
  />
);

export default AvatarImg;
